export default __webpack_public_path__ + "static/media/estadisticas.46effef9.svg";